// themeManager.js на сайтах

export const themeManager = {
  // Список тем для настроек берется прямо из общего скрипта!
  getThemeOptions() {
    return window.HatchupThemes ? window.HatchupThemes.list() : [];
  },

  setTheme(themeValue) {
    if (themeValue && themeValue !== 'default') {
      document.documentElement.setAttribute('data-theme', themeValue);
    } else {
      document.documentElement.removeAttribute('data-theme');
    }
  },

  applyWallpaper(themeValue = '', bgMode = 'none', customUrl = '', bgDim = 65) {
    const themeData = window.HatchupThemes ? window.HatchupThemes.get(themeValue) : null;
    const isLight = themeData?.isLight || themeValue === 'light';
    const alpha = (Math.min(Math.max(bgDim, 0), 100) / 100).toFixed(2);

    const overlay = isLight 
      ? `linear-gradient(rgba(240, 244, 248, ${alpha}), rgba(240, 244, 248, ${alpha}))` 
      : `linear-gradient(rgba(10, 12, 16, ${alpha}), rgba(10, 12, 16, ${alpha}))`;

    if (bgMode === 'theme') {
      const bgUrl = themeData ? themeData.wallpaper : '';
      document.body.style.backgroundImage = `${overlay}, url("${bgUrl}")`;
      document.body.classList.add('has-custom-wallpaper');
    } else if (bgMode === 'custom' && customUrl) {
      document.body.style.backgroundImage = `${overlay}, url("${customUrl}")`;
      document.body.classList.add('has-custom-wallpaper');
    } else {
      document.body.style.backgroundImage = '';
      document.body.classList.remove('has-custom-wallpaper');
    }
  },

  update(settings = {}) {
    const theme = settings.uiTheme || settings.theme || '';
    const bgMode = settings.bgMode || 'none';
    const customUrl = settings.customBgUrl || '';
    const bgDim = settings.bgDim !== undefined ? settings.bgDim : 65;

    this.setTheme(theme);
    this.applyWallpaper(theme, bgMode, customUrl, bgDim);
  }
};